import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Grid, Typography, alpha } from "@mui/material";
import CardBlog from "./CardBlog";
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../../../firebase/firebaseConfig";

const BlogPages = () => {
    const [infoBlogs, setInfoBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    // Obtener datos de Firestore
    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, 'pageinfoblogcalocho'),
            (snapshot) => {
                const arregloInfoBlog = snapshot.docs.map((docInfoBlog) => {
                    return {...docInfoBlog.data(), id: docInfoBlog.id};
                });
                setInfoBlogs(arregloInfoBlog);
                setLoading(false); // Data has been loaded
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        );
        return () => unsubscribe();
    }, []);

    // Carrusel: Actualizar el índice cada 10 segundos
    useEffect(() => {
        if (infoBlogs.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % infoBlogs.length);
            }, 10000); // 10000ms = 10s
            return () => clearInterval(interval);
        }
    }, [infoBlogs.length]);

    // Muestra un indicador de carga mientras se obtienen los datos
    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#5d0303' }} />
            </Box>
        );
    }

    // Mostrar un mensaje si no hay datos
    if (infoBlogs.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return (
        <Box
            justifyContent="center"
            sx={(theme) => ({
                width: '100%',
                backgroundImage:
                  theme.palette.mode === 'light'
                    ? 'linear-gradient(180deg, #5d0303, #FFF)'
                    : `linear-gradient(#02294F, ${alpha('#090E10', 0.0)})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                padding: { xs: 2, sm: 4, md: 8 }, 
            })}
        >
            {/* Solo se muestra el contenido del índice actual */}
            <Grid
                key={infoBlogs[currentIndex].id}
                alignItems="center"
                justifyContent="center"
                sx={{
                    p: { xs: 2, sm: 4, md: 6 },
                    m: { xs: 0, sm: 3, md: 4 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: { xs: '100%', sm: '80%', md: '100%' },
                    mx: 'auto'
                }}
            >
                <Typography
                    sx={{
                        marginBottom: { xs: '2%', sm: '3%' },
                        marginTop: { xs: '16%', sm: '3%' },
                        textAlign: 'center',
                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }
                    }}
                    variant="h3"
                >
                    {infoBlogs[currentIndex].titulo}
                </Typography>
                <Typography
                    sx={{
                        marginBottom: { xs: '1%', sm: '2%' },
                        textAlign: 'center',
                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }
                    }}
                    variant="subtitle1"
                >
                    {infoBlogs[currentIndex].subtitulo}
                </Typography>
                <Typography
                    sx={{
                        marginBottom: { xs: '1%', sm: '2%' },
                        textAlign: 'center',
                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }
                    }}
                    variant="subtitle1"
                >
                    {infoBlogs[currentIndex].descripcion}
                </Typography>
                <Typography
                    sx={{
                        marginBottom: { xs: '1%', sm: '2%' },
                        textAlign: 'center',
                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }
                    }}
                    variant="subtitle1"
                >
                    {infoBlogs[currentIndex].descripcion2}
                </Typography>
            </Grid>
            <CardBlog />
        </Box>
    );
}

export default BlogPages;
